import CreateReducer from '../utils/createReducer'
import CreateActions from '../utils/createActions'
import networkWrapper from '../utils/networkWrapper'

import routerActions from './router'

const prefix = 'user'
const wrapper = networkWrapper.factory(prefix)

const initialState = {
  initialised: false,
  data: null,
}

const reducers = {
  setInitialised: (state, action) => {
    state.initialised = action.payload
  },
  setData: (state, action) => {
    state.data = action.payload
  },
}

const googleProvider = new firebase.auth.GoogleAuthProvider()

const sideEffects = {

  login: () => wrapper('login', async (dispatch, getState) => {
    firebase.auth().signInWithPopup(googleProvider)
  }),

  logout: () => wrapper('logout', async (dispatch, getState) => {
    await firebase.auth().signOut()
    dispatch(routerActions.navigateTo('login'))
    window.location.reload()
  }),

}

const reducer = CreateReducer({
  initialState,
  reducers,
  prefix,
})

const actions = CreateActions({
  reducers,
  prefix,
  sideEffects,
})

export { actions, reducer }
export default actions